import React from 'react';
import properties from '../../constants/Properties';
import locales from '../../locales/LocalesManager';
import { showAudioAlert } from '../../actions/MenuActions';
import storeManager from '../../store/StoreManager';
import mouseUtils from '../../components/utils/MouseUtils';
import { connect } from 'react-redux';
import audioUtils from '../utils/AudioUtils';
import appParameters from '../utils/AppParameters';
import apiServiceUtils from '../utils/ApiServiceUtils';
import apiService from '../../services/ApiService';
import platformDetection from '../utils/PlatformDetection';

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onButtonClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (platformDetection.isSafariNonIOS()) {
            this.props.dispatch(showAudioAlert(-2));
            platformDetection.showSafariAlert = false;

            if (audioUtils.visitedAudioAlerts.indexOf(4) == -1)
                audioUtils.visitedAudioAlerts.push(4);

            if (this.props.hideAudioAlert) {
                apiServiceUtils.executeSafeApiCall(this.setProperties);
            }

            return;
        }

        this.props.dispatch(showAudioAlert(-1));

        if (audioUtils.visitedAudioAlerts.indexOf(this.props.audioAlert) == -1)
            audioUtils.visitedAudioAlerts.push(this.props.audioAlert);

        if (this.props.hideAudioAlert) {
            apiServiceUtils.executeSafeApiCall(this.setProperties);
        }
    },
    setProperties() {
        apiService.getSessionProperties() // check if the user has access
            .then(response => {
                var value = [];

                if (response && response.user && response.user.audio_recording_popups) {
                    var elements = response.user.audio_recording_popups;

                    value.push({show_popup_a: elements.show_popup_a});
                    value.push({show_popup_b: elements.show_popup_b});
                    value.push({show_popup_c: elements.show_popup_c});
                    value.push({show_popup_d: elements.show_popup_d});
                    value.push({show_popup_e: elements.show_popup_e});
                } else {
                    value.push({show_popup_a: false});
                    value.push({show_popup_b: false});
                    value.push({show_popup_c: false});
                    value.push({show_popup_d: false});
                    value.push({show_popup_e: false});
                }

                if (this.props.audioAlert == 0)
                    value[0].show_popup_a = true;

                if (this.props.audioAlert == 1)
                    value[1].show_popup_b = true;

                if (this.props.audioAlert == 2)
                    value[2].show_popup_c = true;

                if (this.props.audioAlert == 3) // video alert
                    value[3].show_popup_d = true;

                if (platformDetection.isSafariNonIOS()) // Safari alert
                    value[4].show_popup_e = true;

                apiService.setItemProperty('audio_recording_popups', appParameters.currentUserId, value);
            });
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver)
            return true;
        else
            return false;
    },
    render() {
        var textColor;
        var fillColor;

        if (this.state.isOver == true) {
            fillColor = properties.SLIDE_VIEWER_BACKGROUND;
            textColor = 'black';
        } else {
            textColor = 'white';
            fillColor = '#444444';
        }

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: fillColor,
            width: properties.DELETE_ALERT_BUTTON_WIDTH,
            height: properties.DELETE_ALERT_BUTTON_HEIGHT,
            top: this.props.topPosition,
            left: this.props.leftPosition,
            borderRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#333333',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            textAlign: 'left'
        };

        const spanStyle = {
            position: 'absolute',
            top: 6,
            fontSize: 16,
            width: properties.DELETE_ALERT_BUTTON_WIDTH - 6,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            alignItems: 'center',
            textAlign: 'center',
            cursor: 'default',
            color: textColor
        };

        return (
            <button id="audioAlertLastFocusableElement" aria-label={this.props.text} style={buttonStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onButtonClick} onClick={this.onButtonClick}>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

const AudioAlertContent = React.createClass({
    getInitialState() {
        return {
            hideAudioAlert: false
        };
    },
    onCheckBoxClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var value = !this.state.hideAudioAlert;

        this.setState({
            hideAudioAlert:value
        });
    },
    resetState() {
        if (this.state.hideAudioAlert == false)
            return;

        setTimeout(function() {
            this.setState({hideAudioAlert: false});
        }.bind(this), 3);
    },
    render() {
        var visible = 'none';
        var showAlert = false;
        var isSafariNonIOS = platformDetection.isSafariNonIOS();

        if (isSafariNonIOS && platformDetection.showSafariAlert) {
            if (audioUtils.visitedAudioAlerts.indexOf(4) == -1)
                showAlert = true;
        } else if (this.props.audioAlert >= 0 && audioUtils.visitedAudioAlerts.indexOf(this.props.audioAlert) == -1)
            showAlert = true;

        if (showAlert)
            visible = 'block';
        else {
            this.resetState();
            return (<div/>);
        }

        const menuStyle = {
            position: 'absolute',
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            left: 0,
            display: visible,
            zIndex: 20000
        };

        const backgroundStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
            top: 0,
            left: 0,
            opacity: 0.4
        };

        const alertHolderStyle = {
            position: 'absolute',
            top: this.props.windowHeight / 2 - (properties.DELETE_ALERT_TOP_BAR_HEIGHT + properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT) / 2,
            left: (this.props.windowWidth - properties.BROWSER_WIDTH - 100) / 2 - properties.DELETE_ALERT_WIDTH / 2
        };

        const topBarStyle = {
            position: 'absolute',
            backgroundColor: properties.DELETE_ALERT_BACKGROUND,
            width: properties.DELETE_ALERT_WIDTH,
            height: properties.DELETE_ALERT_TOP_BAR_HEIGHT,
            top: 0,
            left: 0,
            borderTopLeftRadius: 3,
            borderTopRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: properties.DELETE_ALERT_BACKGROUND
        };

        const titleStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP,
            top: 6,
            fontSize: 22,
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default',
            color: 'white'
        };

        const bottomBarStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: properties.DELETE_ALERT_WIDTH,
            height: properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT,
            top: properties.DELETE_ALERT_TOP_BAR_HEIGHT,
            left: 0,
            borderBottomLeftRadius: 3,
            borderBottomRightRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: 'white'
        };

        const questionStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP,
            top: 20,
            fontSize: 16,
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP,
            height: properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT - 3 * properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_HEIGHT,
            cursor: 'default',
            color: 'black',
            whiteSpace: 'pre-line'
        };

        var buttonTopPosition = properties.DELETE_ALERT_BOTTOM_BAR_HEIGHT - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_HEIGHT;
        var showMessageStyle = {
            position: 'absolute',
            left: properties.DELETE_ALERT_BUTTON_GAP + 28,
            top: buttonTopPosition + 8,
            fontSize: 16,
            width: properties.DELETE_ALERT_WIDTH - 2 * properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_WIDTH - 50,
            height: properties.DELETE_ALERT_BUTTON_HEIGHT,
            cursor: 'default',
            color: 'black',
            whiteSpace: 'pre-line'
        };

        var title = locales.getCaption('AudioAlertTitle', 'audio');
        var question = locales.getCaption('AudioAlertRecording', 'audio');
        var okCaption = locales.getCaption('AudioAlertOk', 'audio');
        var showMessage = locales.getCaption('ShowMessage', 'audio');

        switch(this.props.audioAlert) {
            case 0: {
                question = locales.getCaption('AudioAlertRecording', 'audio');
                break;
            }
            case 1: {
                question = '"' + this.props.audioTitle + '" ' + locales.getCaption('AudioAlertEffects', 'audio');
                break;
            }
            case 2: {
                question = '"' + this.props.audioTitle + '" ' + locales.getCaption('AudioAlertStorySound', 'audio');
                break;
            }
            case 3: {
                question = locales.getCaption('firstVideoMessage', 'other');
                title = locales.getCaption('VideoAlertTitle', 'audio');
                break;
            }
        }

        const checkBoxSize = 18;
        var checkBoxStyle = {
            position: 'absolute',
            width: checkBoxSize,
            height: checkBoxSize,
            top: buttonTopPosition + 6,
            left: properties.DELETE_ALERT_BUTTON_GAP,
            borderRadius: 3,
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: properties.DELETE_ALERT_BACKGROUND,
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            background: 'none'
        };

        var selectorStyle = {
            position: 'absolute',
            width: 10,
            height: 10,
            top: checkBoxSize/2 - 10/2,
            left: checkBoxSize/2 - 10/2,
            background: properties.DELETE_ALERT_BACKGROUND
        };

        if (this.state.hideAudioAlert)
            selectorStyle.display = 'block';
        else
            selectorStyle.display = 'none';

        if (isSafariNonIOS) {
            title = locales.getCaption('SafariAlertTitle', 'other');
            question = locales.getCaption('SafariAlertDescription', 'other');
        }

        return (
            <div style={menuStyle} id="audioAlert">
                <div style={backgroundStyle}/>
                <div style={alertHolderStyle}>
                    <div style={topBarStyle}>
                        <span style={titleStyle}>{title}</span>
                    </div>
                    <div style={bottomBarStyle}>
                        <div style={questionStyle}>{question}</div>
                        <div style={showMessageStyle}>{showMessage}</div>
                        <button id="audioAlertFirstFocusableElement" aria-label={showMessage} style={checkBoxStyle} onTouchEnd={this.onCheckBoxClick} onClick={this.onCheckBoxClick}>
                            <div style={selectorStyle}/>
                        </button>
                        <Button dispatch={this.props.dispatch} hideAudioAlert={this.state.hideAudioAlert} audioAlert={this.props.audioAlert} topPosition={buttonTopPosition} leftPosition={properties.DELETE_ALERT_WIDTH - properties.DELETE_ALERT_BUTTON_GAP - properties.DELETE_ALERT_BUTTON_WIDTH} text={okCaption}/>
                    </div>
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    var audioAlert = state.menu.audioAlert;
    var audioTitle = state.menu.audioTitle;

    if (audioAlert == undefined)
        audioAlert = -1;

    return {
        audioAlert,
        audioTitle
    };
}

export const AudioAlert = connect(mapStateToProps)(AudioAlertContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/AudioAlert.js
 **/